import React, { forwardRef } from 'react';

const Input = forwardRef(
  (
    {
      variant = 'primary',
      customClass = '',
      focusClass = 'focus:ring-2 focus:ring-blue-500 focus:border-transparent',
      ariaLabel,
      ariaDescribedby,
      ...props
    },
    ref,
  ) => {
    const variants = {
      primary: 'border-gray-300 rounded-md pr-6',
      secondary: 'border-gray-300 rounded-lg shadow-md',
      tertiary: 'bg-[#F2F6FA] border-[#F2F6FA] rounded-lg',
    };

    return (
      <input
        {...props}
        ref={ref}
        aria-label={ariaLabel}
        aria-describedby={ariaDescribedby}
        required
        className={`
          w-full sm:max-w-lg lg:max-w-xl text-md focus:outline-none text-black border mt-1
          px-3 py-2
          ${variants[variant]}
          ${customClass}
          ${focusClass}
        `}
      />
    );
  },
);

export default Input;
